import { FormAdapter, FormAlert, FormContainerOptions, FormControlType, FormValues } from '@omegagrid/form';
import { msg } from "@omegagrid/localize";
import rp from '@reporting/rp-app-host';
import { ReportContext } from '@reporting/rp-types/analytics';

export class ContextFormAdapter extends FormAdapter {

	constructor(private reportContext: ReportContext) {
		super();
	}

	getColumns() {
		return [
			{width: 60},
			{width: null},
		];
	}

	async getControls() {
		const chunks = this.reportContext.name.split('/');
		const name = chunks.pop() || '';
		const folder = chunks.length ? chunks.join('/') : '';

		const rows = [
			{row: 0, col: 0, type: FormControlType.Label, value: msg('Folder'), for: 'folder'},
			{row: 0, col: 1, type: FormControlType.TextInput, key: 'folder', value: folder},
			{row: 1, col: 0, type: FormControlType.Label, value: msg('Name'), for: 'name'},
			{row: 1, col: 1, type: FormControlType.TextInput, key: 'name', required: true, value: name}
		];

		return rows;
	}

	getOptions(): FormContainerOptions {
		return {
			caption: null,
			buttonsPosition: 'bottom',
			alertsPosition: 'bottom',
			buttons: [
				"save",
				"close"
			]
		};
	}

	async save(values: Map<string|number, FormValues>): Promise<boolean|FormAlert[]> {
		const formValues = values.get(0);
		this.reportContext.name = [
			formValues.folder as string ?? '',
			formValues.name as string ?? ''
		].join('/').replace(/\/+/g, '/').replace(/^\/+/, '');

		this.reportContext = await rp.ms('analytics').post<ReportContext>(`context`, this.reportContext);
		return true;
	}

};
